<template>
  <div class="dataTransferNews">
    <van-row class="cell">
      <van-row class="border cell-body receipts">
        <van-col span="6" class="title">客户名称</van-col>
        <van-col span="18" class="rightText">{{customerName}}</van-col>
      </van-row>
    </van-row>
    <!-- 归还客户 -->
    <van-row v-if="goodsVoucherType == 3" class="cell">
      <van-row class="border cell-body receipts">
        <van-col span="6" class="title">移交人</van-col>
        <van-col span="18" class="rightText">{{detail.staffTransferName}}</van-col>
      </van-row>
    </van-row>
    <van-row v-if="goodsVoucherType == 2" class="cell">
      <van-row class="border cell-body receipts">
        <van-col span="6" class="title">接收人</van-col>
        <van-col span="18" class="rightText">{{detail.receiverName}}</van-col>
      </van-row>
    </van-row>
    <van-row class="cell">
      <van-row class="border cell-body receipts">
        <van-col span="6" class="title">快递单号</van-col>
        <van-col span="18" class="rightText">{{detail.expressNumber}}</van-col>
      </van-row>
    </van-row>
    <van-row class="cell" style="margin-top: 0.1rem;font-weight: 700;">
      <van-row class="cell-body">
        <van-col span="6" class="title">物品清单</van-col>
      </van-row>
    </van-row>
    <van-row class="cell">
      <van-row class="border cell-body receipts">
        <div v-for="item in goodsDetail" :key="item.id">
          <van-col span="12" class="leftText">{{item.goodsName}}</van-col>
          <van-col span="12" class="rightText">
            <van-stepper style="height: 0.32rem" v-model="item.number" disabled button-size="22px" max="9999" input-width="42px" />
          </van-col>
        </div>
      </van-row>
    </van-row>
    <van-row class="cell" style="margin-top: 0.1rem">
      <van-row class="border cell-body receipts">
        <van-col span="10" class="confirmedRowCol">
          <div class="title">客户确认情况</div>
        </van-col>
        <van-col span="14" class="confirmedRowCol">
          <div class="rightText rightTextBox">
            <span v-if="detail.goodsVoucherStatus != 1">
              <span v-if="detail.goodsVoucherStatus == 2">{{detail.createTime}} 员工（{{detail.staffConfirmName}}） 已确认</span>
              <span v-else>{{detail.createTime}} 已确认</span>
            </span>
            <span v-else>未确认</span>
          </div>
        </van-col>
      </van-row>
      <!-- 客户确认 -->
      <van-row v-if="sign && (detail.goodsVoucherStatus == 3 || detail.goodsVoucherStatus == 4)" class="uploadImgRow">
        <van-col class="uploadImgCol sign-img" span="8">
          <img class="uploadImg" :src="sign" @click="imgPreview(sign)">
        </van-col>
      </van-row>
      <!-- 员工待客户确认 -->
      <div v-if="signImg.length != 0 && detail.goodsVoucherStatus == 2" class="uploadWrap border-bottom" style="padding-left: 0">
        <van-row class="uploadImgRow">
          <van-col class="uploadImgCol" span="8" v-for="(item, index) in signImg" :key="index">
            <img class="uploadImg" :src="item" @click="imgPreview(item)">
          </van-col>
        </van-row>
      </div>
    </van-row>
    <div>
      <div class="labelTitle fs16 border-top fj">附件</div>
      <div v-if="imgList.length != 0" class="uploadWrap border-bottom">
        <van-row class="uploadImgRow">
          <van-col class="uploadImgCol" span="8" v-for="(item, index) in imgList" :key="index">
            <img class="uploadImg" :src="item" @click="imgPreview(item)">
          </van-col>
        </van-row>
      </div>
      <!-- 附件-文件 -->
      <div class="fileList-box">
        <van-row>
          <van-col class="title-goodsRemarks" span="24" v-for="(item, index) in fileList" :key="index" @click="fileFun">{{item}}</van-col>
        </van-row>
      </div>
    </div>

    <div v-if="detail.goodsVoucherStatus == 1 && !isCanConfirm">
      <van-row v-if="goodsVoucherType == 3" class="btnRow">
        <van-col span="24" class="centerText btnRow-note">如对本次交接有疑问，请联系移交人</van-col>
        <van-col span="24" class="centerText confirmText" @click.native="linkSkip('dataTransferNewsSuccess',{},'','')">确认本次接收资料无误</van-col>
      </van-row>
      <van-row v-if="goodsVoucherType == 2" class="btnRow">
        <van-col span="24" class="centerText btnRow-note">如对本次交接有疑问，请联系接收人</van-col>
        <van-col span="24" class="centerText confirmText" @click.native="linkSkip('storeNewsSuccess',{},'','')">确认本次接收资料无误</van-col>
      </van-row>
    </div>
    <div v-if="detail.goodsVoucherStatus != 1 && !isCanConfirm">
      <van-row class="btnRow">
        <van-col span="24" class="centerText btnRow-box">
          <img src="../../assets/wxRenew/pay-success.gif">
          <span>已确认交接</span>
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Row, Col, Toast, List, Button, Dialog, Stepper, ImagePreview } from "vant";

Vue.use(Row)
  .use(Col)
  .use(List)
  .use(Button)
  .use(Dialog)
  .use(Stepper)
  .use(Toast)
  .use(ImagePreview)
export default {
  name: "dataTransferNews",
  data() {
    return {
      detail: {},
      customerName: '',
      canClick: true, // 防止重复点击提交
      goodsVoucherType: '', // 2收到入库 3归还客户
      goodsDetail: [],
      companyId: '',
      accCompanyId: '',
      goodsVoucherId: '',
      isCanConfirm: false,
      fileList: [],
      imgList: [],
      signImg: [],
      sign: '',
      imagePreview: null
    };
  },
  methods: {
   linkSkip(name, params) {
      let self = this
      let param = {
        goodsVoucherId: self.goodsVoucherId,
        accCompanyId: self.accCompanyId,
        companyId: self.companyId,
        goodsVoucherStatus: 3
      }
      if(!this.canClick){
        Toast("请勿重复提交！");
        return
      }
      this.canClick = false;
      let url = '/fc/small/program/goods/voucher/updateVoucherStatusFromCustomer'
      this.$http
        .post(url, param)
        .then(res => {
          if (res.data.code == 200) {
            this.canClick = true;

            if (this.goodsVoucherType == 2) {
              window._hmt.push(['_trackEvent', "资料交接", "客户消息确认收到入库", self.$store.state.acctCompanyInfo.name + '_' + self.detail.staffTransferName]);
            } else {
              window._hmt.push(['_trackEvent', "资料交接", "客户消息确认归还客户", self.$store.state.acctCompanyInfo.name + '_' + self.detail.staffTransferName]);
            }
            this.$router.push({
              name: name,
              params: params
            });
          } else {
            this.canClick = true;
            Toast(res.data.msg);
          }
        })
        .catch(() => {
          Toast("服务器错误，请联系账无忧解决!");
          this.canClick = true;
        });
    },
    getGoodsList() {
      let self = this
      let storeParams = this.$route.query
      this.accCompanyId = storeParams.accCompanyId
      this.companyId = storeParams.companyId
      this.goodsVoucherId = storeParams.goodsVoucherId
      this.isCanConfirm = storeParams.isCanConfirm

      let url = '/fc/small/program/goods/voucher/getOperateRecordDetailForWeb?' + 'goodsVoucherId=' + storeParams.goodsVoucherId + '&accCompanyId=' + storeParams.accCompanyId + '&companyId=' + storeParams.companyId
      this.$http
        .get(url)
        .then(res => {
          if (res.data.code == 200) {
            let detailData = res.data.data
            this.detail = detailData
            this.goodsDetail = detailData.items[0].goodsDetail
            this.customerName = detailData.items[0].customerName
            this.goodsVoucherType = detailData.goodsVoucherType
            if (detailData.goodsVoucherType == 3) {
              document.title = '归还客户确认'
            } else {
              document.title = '收到入库确认'
            }
            // 附件
            let fileList = detailData.files
            if (fileList.length > 0) {
              fileList.forEach((item) => {
                if (item.fileType == 100) { // 签名
                  self.sign = item.filePath
                } else if (item.fileType == 102) { // 员工帮确认
                  self.signImg.push(item.filePath)
                } else {
                  if (item.filePath) {
                    if (self.fileTypeFun(item.filePath)) {
                      self.imgList.push(item.filePath)
                    } else {
                      self.fileList.push(item.fileName)
                    }
                  }
                }
              })
            }
          } else if (res.data.code == 101) {
            console.log(res.data)
          } else {
            Toast(res.data.msg);
          }
        })
        .catch((res) => {
          console.log(res)
        });
    },
    fileTypeFun (filePath) {
      let type = filePath.substring(filePath.lastIndexOf(".") + 1)
      if (type == 'xls' || type == 'xlsx' || type == 'txt' || type == 'doc' || type == 'docx' || type == 'ppt' || type == 'pptx' || type == 'pdf' || type == 'zip' || type == 'rar') {
        return false
      } else {
        return true
      }
    },
    // 附件
    preImgClick(img, index) {
      this.imagePreview = ImagePreview({
        images: this.fileList,
        startPosition: index
      });
    },
    imgPreview (img) {
      console.log(img)
      if (!img) {
        Toast("没有签名记录!");
        return
      }
      this.imagePreview = ImagePreview({
        images: [img],
        startPosition: 0
      });
    }
  },
  
  mounted() {
    this.getGoodsList()
  }
};
</script>
<style lang="stylus" scoped>
.van-tabs{
  .van-tabs__content.van-tabs__content--animated{
    margin: 0 0.12rem;
  }
  .van-tab__pane{
    .content{
      background: #f0f2f2;
    }
  }
}
.empty {
  text-align: center;
  margin-top: 1.4rem;
  img{
    width:0.8rem;
  }
  .desc {
    margin-top: 0.08rem;
    color: #B4BEC7;
    font-size:0.12rem;
  }

}
.cell {
  background-color: #ffffff;
  font-size: 0.16rem;
  padding-left: 0.16rem;
  position: relative;
}

.cell-body {
  padding: 0.12rem;
  padding-left: 0;
}

.cell-title {
  height: 0.6rem;
  line-height: 0.6rem;
  .title {
    color: #1A2633;
    font-size: 0.17rem;
    font-weight: bold;
  }
}

.title {
  color: #1A2633;
  font-size: 0.17rem;
}

.title-name {
  font-weight: bold;
  font-size: 0.16rem;
  line-height: 0.32rem;
}

.rightText {
  text-align: right;
  color: #1a2633;
  font-size: 0.14rem;
  line-height: 0.23rem;
}

.leftText {
  color: #516374;
  font-size: 0.14rem;
}

.type {
  margin-top: 0.08rem;
}

.border {
  border-bottom: 1px solid #f0f2f2;
}
.btnRow {
  text-align: center;
  background-color: #ffffff;
  border-top: 1px solid #f0f2f2;
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  font-size: 0.17rem;
  font-weight: 500;
  box-sizing: border-box;
  line-height: 0.52rem;
}

.btnRow.disabled {
  color: #B4BEC7;
}
.confirmText {
  color: #ffffff;
  height: 0.52rem;
  line-height: 0.52rem;
  background: #1fadf6;
}
.btnRow-note {
  font-size: 0.14rem;
  height: 0.36rem;
  line-height: 0.36rem;
}
.btnRow-box {
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 0.2rem;
    height: 0.2rem;
    margin-right: 0.1rem;
  }
}
.fj {
  margin-top: 0.1rem;
  height: 0.48rem;
  background: #fff;
  padding-left: 0.16rem;
  line-height: 0.48rem;
}
.uploadWrap {
  background: #ffffff;
  padding: 0 0.16rem;

  .uploadImgRow {
    text-align: center;
    padding: 0.08rem 0;
    padding-bottom: 0.2rem;
    .uploadImgCol {
      font-size 0
      position relative
      margin-bottom 0.1rem
    }
    .uploadImg {
      width: 1.04rem;
      height 1.04rem
    }
  }
}
.sign-img img{
  width: 1rem;
  transform:translate(0.4rem, -0.4rem) rotate(90deg);
  -ms-transform:translate(0.4rem, -0.4rem) rotate(90deg); 	/* IE 9 */
  -moz-transform:translate(0.4rem, -0.4rem) rotate(90deg); 	/* Firefox */
  -webkit-transform:translate(0.4rem, -0.4rem) rotate(90deg); /* Safari 和 Chrome */
  -o-transform:translate(0.4rem, -0.4rem) rotate(90deg);
}
.sign-img {
  height: 1.4rem;
}
</style>

<style>
.dataTransferNews .van-stepper button {
  display: none;
}
.dataTransferNews .van-stepper__minus,
.dataTransferNews .van-stepper__plus {
  border-radius: 0 2px 2px 0;
}
</style>

